<template>
  <v-app>
    <Header
      v-if="is_show"
      :experience="experience"
      :view="view"
      :is-install="is_install"
      :init-step-historys="step_historys"
      :init-step-history-index="step_history_index"
      :view-data="view_data"
      :default-device-type="device_type"
    />

    <Container v-if="is_show" :step_historys="sdk_historys" :src="src" :is_install="is_install" :view="view" />

    <!-- <Editor 
            v-if="is_show"
            :init_step_historys="step_historys"
            :init_step_history_index="step_history_index"
            :vid="this.view.vid"
        /> -->

    <component
      :is="editor_component_name"
      v-if="is_show && is_open_editor"
      id="edit_tool"
      ref="dynamicComponent"
      class="edit_tool"
      v-bind="component_props"
      @callback="callbackDynamicComponent"
    />

    <v-dialog v-if="dialog_setting.is_show" v-model="dialog_setting.is_show" width="500">
      <v-card>
        <v-card-title>
          {{ dialog_setting.title }}
        </v-card-title>

        <v-card-text v-if="dialog_setting.mode === 'waitIframe'">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              {{ dialog_setting.text }}
            </v-col>
            <v-col cols="12">
              <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="pt-4">
          <v-alert
            v-if="dialog_setting.alert_type.is_show"
            dense
            :type="dialog_setting.alert_type.type"
            :color="dialog_setting.alert_type.color"
            :icon="dialog_setting.alert_type.color.icon"
            class="mb-0"
          >
            {{ dialog_setting.text }}
          </v-alert>
          <p v-if="dialog_setting.alert_type.is_show === false" class="mb-0">
            {{ dialog_setting.text }}
          </p>

          <div v-if="dialog_setting.html" v-html="dialog_setting.html"></div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            v-for="(btn, idx) in dialog_setting.btns"
            :key="idx"
            :color="btn.color"
            text
            @click="btn.callback(dialog_setting.data)"
          >
            {{ btn.text }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="is_upload_img" v-model="is_upload_img" width="800" @click:outside="cancelUploadImg">
      <v-card>
        <v-card-title> 選擇圖片 </v-card-title>

        <v-card-text class="pb-0 pt-2">
          <v-tabs v-model="tab">
            <v-tab href="#tab-1"> 電腦上傳 </v-tab>
            <v-tab href="#tab-2"> 圖片網址 </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item :value="'tab-1'" class="pt-4">
              <div v-if="img_file" class="d-flex justify-center mb-4">
                <v-img v-if="img_file" contain max-height="120" max-width="120" :src="getBlob(img_file)"></v-img>
              </div>
              <div v-else class="mb-4">
                <v-skeleton-loader
                  type="image"
                  max-height="120"
                  max-width="120"
                  class="default-img"
                ></v-skeleton-loader>
              </div>
              <div class="text-subtitle-2 mb-2">選擇圖檔:</div>
              <v-file-input
                v-model="img_file"
                prepend-icon=""
                outlined
                dense
                accept="image/png, image/jpeg, image/jpg"
                :error-messages="upload_img_error_msg"
                append-icon="mdi-tray-arrow-up"
                @change="selectedImg"
              ></v-file-input>
            </v-tab-item>
            <v-tab-item :value="'tab-2'" class="pt-4">
              <div v-if="img_url" class="d-flex justify-center mb-4">
                <v-img v-if="img_url" contain max-height="120" max-width="120" :src="img_url"></v-img>
              </div>
              <div v-else class="mb-4">
                <v-skeleton-loader
                  type="image"
                  max-height="120"
                  max-width="120"
                  class="default-img"
                ></v-skeleton-loader>
              </div>
              <div class="text-subtitle-2 mb-2">圖片網址:</div>
              <v-text-field v-model="img_url" dense outlined :error-messages="url_img_error_msg" @input="inputImg">
              </v-text-field>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-text v-if="upload_type === 'init'">
          <div class="text-subtitle-2 mb-2">插入位置:</div>
          <div style="max-width: 15em">
            <v-select
              v-model="selected_item"
              return-object
              outlined
              dense
              :items="items"
              :error-messages="insert_error_msg"
            >
            </v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="'grey'" text @click="cancelUploadImg"> 取消 </v-btn>
          <v-btn color="primary" text @click="confirmUploadImg"> 確定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { apiGetExperience, apiGetView } from '@/api/optimize.js'
import Header from '@/views/OptimizePage/Experiment/Components/Header.vue'
import Container from '@/views/OptimizePage/Experiment/Components/Container.vue'
import Editor from '@/views/OptimizePage/Experiment/Components/Editor.vue'
import { eventBus } from '@/event_bus.js'
import { mapGetters, mapMutations } from 'vuex'
import AnimationEditor from '@/views/OptimizePage/Experiment/Components/AnimationEditor.vue'
import ElementSort from '@/views/OptimizePage/Experiment/Components/ElementSort.vue'
import Carousel from '@/views/OptimizePage/Experiment/Components/Carousel.vue'
import { apiUploadImage } from '@/api/common.js'
import drag from '@/composables/drag'
export default {
  name: 'OptimizePageEditorApp',
  components: {
    Header,
    Container,
    Editor,
    AnimationEditor,
    ElementSort,
    Carousel,
  },
  data() {
    return {
      org_id: '',
      experience_id: '',
      experience: null,
      view: null,
      view_data: null,
      src: null,
      is_show: false,
      is_install: false,
      dialog_setting: {
        is_show: false,
      },
      step_historys: [],
      step_history_index: -1,
      device_type: {},
      device_type_mapper: {
        desktop: {
          id: 'desktop',
          icon: 'mdi-monitor',
          name: '桌機',
        },
        tablet: {
          id: 'tablet',
          icon: 'mdi-tablet',
          name: '平板',
        },
        mobile: {
          id: 'mobile',
          icon: 'mdi-cellphone',
          name: '手機',
        },
      },
      is_upload_img: false,
      img_url: '',
      img_file: null,
      upload_img_error_msg: '',
      url_img_error_msg: '',
      upload_type: '',
      tab: null,

      selected_item: {
        text: 'Before',
        value: 'beforebegin',
        description: '插入至選取元素外的上方',
        highlight: '',
      },
      items: [
        {
          text: 'Before',
          value: 'beforebegin',
          description: '插入至選取元素外的上方',
          highlight: '',
        },
        {
          text: 'After',
          value: 'afterend',
          description: '插入至選取元素外的下方',
          highlight: '',
        },
      ],
      insert_error_msg: '',
      exclude_editors: ['Interactor'],
      sdk_historys: [],
      editor_component_name: '',
    }
  },
  computed: {
    component_props() {
      const type = {
        Editor: {
          vid: this.view.vid,
          init_step_historys: this.step_historys,
          init_step_history_index: this.step_history_index,
        },
        AnimationEditor: {
          vid: this.view.vid,
          init_step_historys: this.step_historys,
          init_step_history_index: this.step_history_index,
        },
        elementSort: {
          vid: this.view.vid,
          init_step_historys: this.step_historys,
          init_step_history_index: this.step_history_index,
        },
        Carousel: {
          vid: this.view.vid,
          init_step_historys: this.step_historys,
          init_step_history_index: this.step_history_index,
        },
      }
      return type[this.editor_component_name] ? type[this.editor_component_name] : {}
    },
    // optimize 命名空間的 Getters
    ...mapGetters('optimize', ['activate_editor', 'catch_iframe_selected_data', 'is_open_editor']),
  },
  watch: {
    activate_editor(new_val, old_val) {
      console.log('activate_edito_old_val', old_val)
      console.log('activate_edito_new_val', new_val)
      // 切換過工具才開始清 EventListener
      if (old_val) {
        if (document.getElementById('edit_tool')) {
          // document.getElementById('edit_tool').removeEventListener('pointerdown', this.dragStart)
        }
      }
      if (new_val === 'Interactor') {
        this.editor_component_name = old_val
      } else {
        this.editor_component_name = new_val
      }

      eventBus.$emit('action-to-page', {
        action: 'actionToPage',
        data: {
          event: 'overlay',
          value: true,
        },
      })

      this.$nextTick(() => {
        // 新工具渲染完才執行 addEventListener
        if (new_val) {
          setTimeout(() => {
            if (document.querySelector('.optimize99-ab-test-editor-header')) {
              document
                .querySelector('.optimize99-ab-test-editor-header')
                .addEventListener('pointerdown', this.dragStart)
            }
          })
        }
        switch (new_val) {
          case 'AnimationEditor':
            console.log('getcallback', AnimationEditor)
            console.log('child', this.$refs.dynamicComponent)
            if (this.$refs.dynamicComponent && this.$refs.dynamicComponent.init) {
              this.$refs.dynamicComponent.init(
                this.original_info,
                this.selected_element_selector,
                this.selected_element_info,
                this.plugin_param
              )
            } else {
              console.error('Child method not found')
            }

            break
          case 'Interactor':
            eventBus.$emit('action-to-page', {
              action: 'actionToPage',
              data: {
                event: 'overlay',
                value: false,
                mode: 'interactor',
                is_lock_click: true,
              },
            })
            break
          default:
            eventBus.$emit('edit-text', false)
        }
      })
    },
    catch_iframe_selected_data: {
      handler(newValue) {
        console.log('back_app_newValue', newValue)
        if (newValue && newValue.is_need_update_history) {
          switch (newValue.platform_step.type) {
            case 'remove_animation': {
              let step = JSON.parse(JSON.stringify(newValue.platform_step))
              step.selector = newValue.selected_element_selector
              this.recordHistory(step)
              break
            }

            case 'sort_element': {
              console.log('back_app', 'sort_ele')
              eventBus.$emit('update-sort-result', newValue)
              break
            }

            case 'carousel': {
              if (
                newValue.update_result.carousel_data?.carousel_new_id &&
                !newValue.update_result.carousel_data?.is_preview
              ) {
                this.$store.commit('optimize/CAROUSEL_PREVIOUS_DATA', newValue.update_result.carousel_data)
                this.$store.commit(
                  'optimize/SDK_CAROUSEL_NEW_ID',
                  `carousel-${newValue.update_result.carousel_data.carousel_new_id.match(/\d+/g).map(Number)[0] + 1}`
                )
              }
              break
            }

            default:
              console.log('back_app_update_history_not_match', newValue)
          }
        }
      },
      deep: true,
    },
  },
  // beforeCreate() {
  //     if (!this.$store.hasModule('optimize')) {
  //         this.$store.registerModule('optimize');
  //     }
  // },
  // beforeDestroy() {
  //     if (this.$store.hasModule('optimize')) {
  //         this.$store.unregisterModule('optimize');
  //     }
  // },
  async created() {
    this.org_id = this.$route.params.org_id
    eventBus.$on('open-dialog', this.openDialog)
    eventBus.$on('update-editor-ele', this.updateEditorEle)
    eventBus.$on('update-header-history', this.updateHistory)
    eventBus.$on('interact-result', this.recordHistory)
  },
  beforeDestroy() {
    if (document.getElementById('edit_tool')) {
      document.getElementById('edit_tool').removeEventListener('pointerdown', this.dragStart)
    }

    // 換頁時重置 store/optimize state
    this.$store.commit('optimize/RESET_STATE')
  },
  destroyed() {
    eventBus.$off('open-dialog', this.openDialog)
  },
  async mounted() {
    // 清空前次紀錄
    // this.$store.commit('setIsShowSidebar', false)
    this.$store.commit('setDeviceType', 'desktop')

    console.log('step_historys', this.step_historys)
    console.log('rrrrrr', this.$route)

    let url_query = this.$route.query

    if (!url_query.experience_id || !url_query.view_id) {
      if (url_query.is_install !== 'true') {
        this.$router.go(-1)
        return
      }
    }

    if (url_query.is_install === 'true') {
      this.is_install = true
    } else {
      this.is_install = false
    }

    if (!this.is_install) {
      this.experience = await this.getExperience(url_query.experience_id, this.org_id)
      this.view = await this.getView(url_query.view_id, this.org_id)
      if (!this.experience || !this.view) {
        this.$router.go(-1)
        return
      }
    }
    this.view_data = JSON.parse(JSON.stringify(this.view))
    this.view = JSON.parse(JSON.stringify(this.view.view))

    // 初始化歷史紀錄
    if (!this.is_install) {
      // 區分是新版還是舊版
      let is_new = false
      let sdk_history_files = []
      let step_history_files = []
      try {
        step_history_files = JSON.parse(this.view.over_pc)
        sdk_history_files = JSON.parse(this.view.over_pc)
        is_new = true
      } catch (error) {
        console.log('app-parse-step-error', error)
      }
      this.$root.vprogress.init({
        message: `讀取紀錄中...`,
      })

      this.$root.vprogress.setValue(0)
      this.$root.vprogress.show()

      if (is_new) {
        let sdk_historys = []
        let step_historys = []
        for (let idx = 0; idx < sdk_history_files.length; idx++) {
          const progress = ((idx + 1) / step_history_files.length) * 100
          this.$root.vprogress.setText(`讀取紀錄中....(${idx}/${step_history_files.length})`)
          this.$root.vprogress.setValue(progress)
          try {
            let result = await this.$utils.getFile(`https://pic.optimize99.com/api/img/${sdk_history_files[idx]}`)
            console.log('read1-result', result)
            result = JSON.parse(result)
            sdk_historys = sdk_historys.concat(result)
            console.log('result', result)
          } catch (error) {
            console.log('read1-error', error)
          }
        }
        for (let idx = 0; idx < step_history_files.length; idx++) {
          try {
            let result = await this.$utils.getFile(`https://pic.optimize99.com/api/img/${step_history_files[idx]}`)
            result = JSON.parse(result)
            step_historys = step_historys.concat(result)
            console.log('read2-result', result)
            console.log('result', result)
          } catch (error) {
            console.log('read2-error', error)
          }
        }

        this.step_historys = JSON.parse(JSON.stringify(step_historys)) || []
        this.step_history_index = step_historys.length - 1
        this.sdk_historys = JSON.parse(JSON.stringify(sdk_historys)) || []
      } else {
        if (this.view && this.view.add_column) {
          let add_column = JSON.parse(this.view.add_column)
          if (Array.isArray(add_column.history)) {
            this.step_historys = add_column.history
            this.step_history_index = add_column.history.length - 1
            this.sdk_historys = JSON.parse(JSON.stringify(this.step_historys))
          }
        }
      }
    }

    console.log('APPPPPPP', this.view)
    console.log('step_historys', this.step_historys)
    console.log('step_idx', this.step_history_index)
    console.log('view_data', this.view_data)
    console.log('ab_test', this.view)
    const randomUUID = uuidv4()
    let url_src = ''

    if (url_query.url) {
      url_src = url_query.url
    } else {
      url_src = decodeURIComponent(decodeURIComponent(this.experience.url))
    }
    console.log('url_src', url_src)
    url_src = new URL(url_src)
    url_src.searchParams.append('opt99_edit', 'true')
    url_src.searchParams.append('uuid', randomUUID)
    url_src.searchParams.append('vid', this.view.vid)

    this.src = url_src.href

    if (this.device_type_mapper[url_query.device_type]) {
      this.device_type = this.device_type_mapper[url_query.device_type]
    } else {
      this.device_type = this.device_type_mapper['desktop']
    }
    console.log('device_type', this.device_type)
    this.$store.commit('setDeviceType', this.device_type.id)
    this.$root.vprogress.setText('載入完成，即將開始載入編輯器。')

    setTimeout(() => {
      this.$root.vprogress.hide()
      this.is_show = true
    }, 1000)

    // 關閉或重新整理頁面時，重置 store/optimize state
    window.addEventListener('beforeunload', () => {
      this.$store.commit('optimize/RESET_STATE')
    })
  },
  methods: {
    dragStart() {
      const edit_tool_el = document.getElementById('edit_tool')
      if (edit_tool_el) {
        drag({ main_el: edit_tool_el, top_boundary: 96 })
      }
    },
    async getExperience(id, org_id) {
      let data = await apiGetExperience(id, org_id)
        .then(function (resp) {
          return resp.data.data
        })
        .catch(function (error) {
          console.log('get_e_error', error)
          return null
        })

      return data
    },
    async getView(id, org_id) {
      let data = await apiGetView(id, org_id)
        .then(function (resp) {
          return resp.data.data
        })
        .catch(function (error) {
          console.log('get_v_error', error)
          return null
        })

      return data
    },
    openDialog(dialog_setting) {
      let that = this
      console.log('dialog_setting', dialog_setting)
      if (dialog_setting.is_show === false) {
        this.dialog_setting.is_show = false
        return
      }

      that.dialog_setting = dialog_setting

      if (dialog_setting.time) {
        setTimeout(function () {
          that.dialog_setting.is_show = false
        }, dialog_setting.time)
      }
    },
    updateEditorEle(data) {
      console.log('app-callback_data:', data)
      this.original_info = JSON.parse(JSON.stringify(data.selected_element_info))
      console.log('app-callback_data:', this.original_info)
      this.selected_element_selector = data.selected_element_selector
      this.selected_element_info = data.selected_element_info
      // this.editor_type = data.editor_type
      this.plugin_type = data.plugin_type
      this.plugin_param = data.plugin_param
      if (this.plugin_type === 'animation' && this.activate_editor === 'Editor') {
        eventBus.$emit('change-editor', 'AnimationEditor')
      }

      // console.log('app-update', this.setEditor)
      // if (this.plugin_type === 'animation') {
      //     this.setEditor('AnimationEditor')
      // }
      // else {
      //     this.setEditor('')
      // }
    },
    callbackDynamicComponent(action) {
      console.log('action', action)
      switch (action.name) {
        case 'uploadImg':
          this.is_upload_img = true
          this.upload_type = action.upload_type
          break
      }
    },
    cancelUploadImg() {
      this.is_upload_img = false
      this.img_url = ''
      this.img_file = null
    },
    async confirmUploadImg() {
      console.log('tab', this.tab)
      if (this.upload_type === 'init' && !this.selected_item) {
        this.insert_error_msg = '請選擇插入位置。'
        return
      }
      let img_src = ''
      if (this.tab === 'tab-2') {
        img_src = this.img_url
        if (!img_src) {
          this.url_img_error_msg = '請輸入圖片網址。'
          return
        }
      } else {
        let result = this.$utils.checkFileSize(this.img_file)
        console.log('result', result)
        if (!result.result) {
          this.upload_img_error_msg = result.default_msg
          return
        }

        //  上傳圖片
        try {
          let data = new FormData()
          data.append('file', this.img_file)
          data.append('category', this.$route.params.container_id)
          data.append('group_id', `vid:${this.view.vid}`)
          let upload_result = await apiUploadImage(data)
          console.log('upload_result', upload_result)
          img_src = upload_result
        } catch (error) {
          console.log('upload_error', error)
          this.$root.vtoast.show({
            message: '上傳圖片失敗，原因: ' + error,
          })
        }
      }

      console.log('component', this.$refs.dynamicComponent)
      console.log('upload_type', this.upload_type)
      if (this.upload_type === 'init') {
        if (this.$refs.dynamicComponent && this.$refs.dynamicComponent.startEdit) {
          this.$refs.dynamicComponent.startEdit(img_src, this.selected_element_selector, this.selected_item.value)
        }
      } else {
        if (this.$refs.dynamicComponent && this.$refs.dynamicComponent.insertLayer) {
          this.$refs.dynamicComponent.insertLayer(img_src, this.selected_element_selector)
        }
      }

      console.log('img_src', img_src)

      this.is_upload_img = false
      this.upload_img_error_msg = ''
      this.img_url = ''
      this.img_file = null
      this.tab = 'tab-1'
      this.insert_error_msg = ''
    },
    selectedImg() {
      console.log('selected_img', this.img_file)
      let result = this.$utils.checkFileSize(this.img_file)
      if (!result.result) {
        this.upload_img_error_msg = result.default_msg
      } else {
        this.upload_img_error_msg = ''
      }
    },
    inputImg() {
      console.log('inputImg', this.img_url)
    },
    getBlob(file) {
      return URL.createObjectURL(file)
    },
    updateHistory: function (historys, history_idx) {
      console.log('app更新歷史', historys)
      console.log('app更新歷史', history_idx)
      this.step_historys = historys
      this.step_history_index = history_idx
    },
    recordHistory: function (data) {
      let step_historys = this.step_historys
      let idx = this.step_history_index

      // 把目前這index當作最新的，之後的全刪掉
      step_historys.splice(idx + 1, step_historys.length - idx - 1)
      // 推進去歷史紀錄
      data.original_info = this.selected_element_info
      step_historys.push(data)
      idx = step_historys.length - 1

      eventBus.$emit('update-header-history', step_historys, idx)
      eventBus.$emit('update-editor-history', step_historys, idx)
      this.step_historys = step_historys
      this.step_history_index = idx
    },
    ...mapMutations('optimize', ['setEditor']),
  },
}
</script>

<style>
.default-img {
  margin: 0 auto;
}

.edit_tool {
  position: fixed;
  z-index: 3;
  bottom: 15px;
  right: 15px;
}
.optimize99-ab-test-editor-header {
  cursor: move;
}
</style>
